// Data saved by the old Vue Pulser Studio (same origin, same keys) breaks the
// React app, and stale layouts keep old golden-layout settings. Wipe them once.
// Bump STORAGE_VERSION to force another wipe after a breaking change.
// Must be imported before any module that reads localStorage at load time.
const STORAGE_VERSION = '1';
const STORAGE_VERSION_KEY = 'storage-version';
const LEGACY_KEYS = ['experiments', 'exp5-layout', 'exp6-layout'];

if (localStorage.getItem(STORAGE_VERSION_KEY) !== STORAGE_VERSION) {
  LEGACY_KEYS.forEach((key) => localStorage.removeItem(key));
  localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);
}
